import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: null,
};

export const currentEventSlice = createSlice({
  name: 'currentEvent',
  initialState,
  reducers: {
    setCurrentEvent: (state, action) => {
      state.value = action.payload
    },
  },
});

export const { setCurrentEvent } = currentEventSlice.actions;

export default currentEventSlice.reducer;